// NOTE: This will be overridden in app -> provider level (for example: FieldMissionProvider and its components) as this relies to regionalized urls after selecting a project in app level (C3D) OR adding custom params in tcRegion/tcProjectId (Mapviewer)

export const DEFAULT_FEATURES_SERVICE_URLS = {
  featuresApi:
    'https://cloud.stage.api.trimblecloud.com/Features-Service/features-na/1.0/',
  tilesApi:
    'https://cloud.stage.api.trimblecloud.com/features-service/features-na/v1.0-stage',
} as const;
